import React from 'react';
import { Video } from 'components/video/Video';

export const Component = () => {
  const image = { url: '/static/images/alvotech-meeting.jpg', width: 100, height: 100 };

  return (
    <Video
      embed={{ type: 'video', embedUrl: 'https://vimeo.com/346836128', html: '' }}
      placeholder={image}
      title="Video title"
      tagline="Video tagline"
      isSlice
    />
  );
};
